export default __webpack_public_path__ + "src/blocks/services/img/service-pattern.png";